import { getFirestore, doc, setDoc, getDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const db = getFirestore();

export const getUserData = async (email) => {
  const docRef = doc(db, "Grow", email);
  const docSnap = await getDoc(docRef);
  console.log(docSnap.exists() ? docSnap.data().climate_soil : false);
  return docSnap.exists() ? docSnap.data() : null;
};

export const createUser = async (email, data) => {
  const docRef = doc(db, "Grow", email);
  await setDoc(docRef, data);
};

export const updateUserField = async (email, field, value) => {
  const docRef = doc(db, "Grow_Admin", email);
  await setDoc(docRef, { [field]: value });
};

export const appendToFieldArray = async (email, field, value) => {
  const docRef = doc(db, "Grow", email);
  await updateDoc(docRef, { [field]: arrayUnion(value) });
};

export const updateCropAddField = async (email, name, field ) => {
  // console.log(field);
  // console.log(email);
  const docRef = doc(db, "Grow_Admin", email);
  await setDoc(docRef, {
    crop_add : { crop_name : name,  field_size : field }
  });
};


// Fetch user crops
export const getUserCrops = async (email) => {
  const docRef = doc(db, "Grow", email); // Reference to the user's document in Firestore
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().known_crops || []; // Fetch crops or return empty array if no crops exist
  }
  return [];
};

// Fetch user crops
export const getUserSoilClimate = async (email) => {
  const docRef = doc(db, "Grow", email); // Reference to the user's document in Firestore
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().climate_soil || []; // Fetch crops or return empty array if no crops exist
  }
  return [];
};

// Append a crop to the user's list of crops
export const appendToUserCrops = async (email, crop) => {
  const docRef = doc(db, "Grow", email);
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) {
    await setDoc(docRef, {
      known_crops: [crop], // Initialize with the selected crop
    });
  } else {
    await updateDoc(docRef, {
      known_crops: arrayUnion(crop), // Add the crop to the known_crops array
    });
  }
};

export const removeFromUserCrops = async (email, crop) => {
  const docRef = doc(db, "Grow", email);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    await updateDoc(docRef, {
      known_crops: arrayRemove(crop), // Remove the crop from the known_crops array
    });
  } else {
    console.log("Document doesn't exist. No crop to remove.");
  }
};


// Fetch the estimation meet data from Grow_Admin collection
export const getEstimationMeetData = async () => {
  try {
    const docRef = doc(db, "Grow_Admin", "crop_estimation@matops-grow.web.app");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data().estimation_meet;
    } else {
      throw new Error("No data found.");
    }
  } catch (err) {
    throw new Error("Error fetching data: " + err.message);
  }
};


// Fetch user sowing data
export const getUserSowing = async (email) => {
  const docRef = doc(db, "Grow", email); // Reference to the user's document
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    // Return the sowing field or empty array if not present
    return docSnap.data().sowing || [];
  }
  return [];
};
